<div class="topbar flex items-stretch flex-shrink-0" style="
    background: var(--topbar-bg);
    border-bottom: 1px solid var(--topbar-border);
    min-height: 42px;
    position: relative;
    z-index: 20;
  ">
  <!-- ── Hamburger (CSS shows it only on mobile via .hamburger-btn class) ── -->
  <button class="hamburger-btn items-center justify-center flex-shrink-0 w-10 self-center ml-1"
    style="color: var(--text-secondary)" title="Open menu" (click)="toggleDrawer.emit()">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  </button>

  <!-- ── Tabs area wrapper (holds arrows + scroll container) ── -->
  <div class="relative flex items-stretch flex-1 min-w-0">

    <!-- Left scroll arrow (fade overlay) -->
    @if (canScrollLeft()) {
    <div class="absolute left-0 top-0 bottom-0 z-10 flex items-center pointer-events-none" style="
          width: 48px;
          background: linear-gradient(to right, var(--topbar-bg) 50%, transparent);
        ">
      <button class="tab-scroll-btn pointer-events-auto ml-1 w-6 h-6 rounded-md flex items-center justify-center"
        title="Scroll left" (click)="scrollTabsBy(-160)">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
    </div>
    }

    <!-- Tabs scroll container -->
    <div #tabsScroll class="flex items-end flex-1 overflow-x-auto min-w-0"
      style="scrollbar-width: none; -ms-overflow-style: none; padding-left: 6px; padding-top: 6px;"
      (scroll)="onTabScroll($event)">
      @for (tab of tabService.tabs(); track tab.id; let i = $index) {
      @let isActive = tabService.activeTabId() === tab.id;
      <div
        class="relative flex items-center gap-1.5 px-3 py-1.5 cursor-pointer flex-shrink-0 max-w-[180px] rounded-t-lg select-none transition-colors group"
        [attr.data-active]="isActive" [style.background]="isActive ? 'var(--tab-active-bg)' : 'var(--tab-inactive-bg)'"
        [style.color]="isActive ? 'var(--tab-active-text)' : 'var(--tab-text)'"
        [style.font-weight]="isActive ? '600' : '400'"
        [style.border-top]="isActive ? '2px solid var(--primary)' : '1.5px solid var(--topbar-border)'"
        [style.border-left]="'1px solid var(--topbar-border)'" [style.border-right]="'1px solid var(--topbar-border)'"
        [style.border-bottom]="isActive ? '1px solid var(--tab-active-bg)' : 'none'"
        [style.margin-bottom]="isActive ? '-1px' : '0'" [style.margin-top]="isActive ? '0' : '2px'"
        [style.margin-right]="'2px'" [style.z-index]="isActive ? '3' : '1'"
        [style.box-shadow]="isActive ? '0 -2px 8px rgba(0,0,0,0.06)' : 'none'" (click)="activate(tab.id, tab.route)"
        (keydown.enter)="activate(tab.id, tab.route)"
        (keydown.space)="$event.preventDefault(); activate(tab.id, tab.route)"
        (contextmenu)="onTabRightClick(tab.id, $event)">
        <svg class="w-3.5 h-3.5 flex-shrink-0 transition-opacity"
          [style.color]="isActive ? 'var(--primary)' : 'currentColor'" [style.opacity]="isActive ? '0.8' : '0.4'"
          fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z" />
        </svg>
        <span class="text-xs truncate flex-1">{{ tab.title }}</span>
        @if (tab.closeable !== false) {
        <button class="tab-close-btn w-4 h-4 rounded flex items-center justify-center flex-shrink-0"
          (click)="close(tab.id, $event)">
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        }
      </div>
      }
    </div>
    <!-- /tabsScroll -->

    <!-- Right scroll arrow (fade overlay) -->
    @if (canScrollRight()) {
    <div class="absolute right-0 top-0 bottom-0 z-10 flex items-center justify-end pointer-events-none" style="
          width: 48px;
          background: linear-gradient(to left, var(--topbar-bg) 50%, transparent);
        ">
      <button class="tab-scroll-btn pointer-events-auto mr-1 w-6 h-6 rounded-md flex items-center justify-center"
        title="Scroll right" (click)="scrollTabsBy(160)">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
    }

  </div>
  <!-- /tabs area wrapper -->

  <!-- ── Right toolbar ── -->
  <div class="flex items-center gap-2 px-2 sm:px-3 flex-shrink-0 self-center my-1"
    style="border-left: 1px solid var(--topbar-border)">
    @if (creditStore.showInHeader()) {
    <a routerLink="/usage"
      class="header-credits-badge group relative inline-flex items-center gap-1.5 rounded-full border px-1.5 py-0.5 no-underline transition hover:opacity-90"
      [class.header-credits-badge--success]="creditStore.remainingLevel() === 'success'"
      [class.header-credits-badge--warning]="creditStore.remainingLevel() === 'warning'"
      [class.header-credits-badge--danger]="creditStore.remainingLevel() === 'danger'"
      [attr.aria-label]="remainingCreditsLabel()">
      <span class="header-credits-icon flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
        aria-hidden="true">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m0 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v3" />
        </svg>
      </span>
      <span class="header-credits-amount">{{ creditStore.remainingCredits() | number }}</span>
      <span class="header-credits-tooltip" role="tooltip">Remaining credits</span>
    </a>
    <span class="header-toolbar-divider" aria-hidden="true">|</span>
    }

    <!-- ─ Profile / triple-dot menu ─ -->
    <div class="relative">
      <button class="flex items-center gap-1.5 rounded-lg px-1.5 py-1 transition-all hover:opacity-80"
        style="color: var(--text-secondary)" [style.background]="profileOpen() ? 'var(--border-light)' : 'transparent'"
        title="Profile & settings" (click)="profileOpen.set(!profileOpen()); notifOpen.set(false)">
        <!-- Avatar -->
        <div
          class="w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] font-bold flex-shrink-0 cursor-pointer"
          style="background: var(--primary)">
          {{ userInitials() }}
        </div>
        <!-- Triple dot icon -->
        <svg class="w-3.5 h-3.5 opacity-60" fill="currentColor" viewBox="0 0 24 24">
          <circle cx="5" cy="12" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="19" cy="12" r="2" />
        </svg>
      </button>

      <!-- Profile dropdown -->
      @if (profileOpen()) {
      <div class="fixed inset-0 z-40" (click)="profileOpen.set(false)" (keydown)="onProfileBackdropKeydown($event)">
      </div>
      <div class="absolute right-0 mt-1.5 rounded-xl shadow-2xl z-50 overflow-hidden" style="
            top: 100%;
            width: 220px;
            background: var(--card-bg);
            border: 1px solid var(--card-border);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          ">
        <!-- User info: not a button — stopPropagation so this block never acts like a menu action -->
        <div class="px-4 py-3.5 border-b cursor-default" style="border-color: var(--card-border)"
          (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <div class="flex items-center gap-3">
            <div
              class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0"
              style="background: var(--primary)">
              {{ userInitials() }}
            </div>
            <div class="min-w-0">
              <div class="text-sm font-semibold truncate" style="color: var(--text-primary)">
                {{ userDisplayName() }}
              </div>
              <div class="text-xs truncate" style="color: var(--text-muted)">{{ userSubtitle() }}</div>
            </div>
          </div>
        </div>

        <!-- Menu items -->
        <div class="py-1.5">
          @for (item of profileMenuItems; track item.label) {
          @if (item.divider) {
          <div class="my-1.5 border-t" style="border-color: var(--card-border)"></div>
          } @else {
          <button
            class="w-full flex items-center gap-3 px-4 py-2 text-sm transition-all hover:opacity-80 text-left cursor-pointer"
            [style.color]="item.danger ? 'var(--danger)' : 'var(--text-secondary)'" [style.background]="'transparent'"
            (click)="item.action(); profileOpen.set(false)">
            <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="item.icon" />
            </svg>
            {{ item.label }}
          </button>
          }
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>

<!-- ── Tab Context Menu ── -->
@if (contextMenu()) {
<!-- Invisible overlay to capture clicks outside -->
<div class="fixed inset-0 z-[9998]" (click)="dismissContextMenu()" (contextmenu)="dismissContextMenu()"
  (keydown)="onContextMenuBackdropKeydown($event)"></div>
<div class="fixed z-[9999] rounded-xl overflow-hidden py-1.5" [style.left.px]="contextMenu()!.x"
  [style.top.px]="contextMenu()!.y" style="
      background: var(--dropdown-bg);
      border: 1px solid var(--dropdown-border);
      box-shadow: var(--dropdown-shadow);
      min-width: 210px;
    ">
  <!-- Close Tab -->
  <button class="ctx-menu-item w-full flex items-center gap-3 px-3.5 py-2 text-xs font-medium text-left"
    style="color: var(--dropdown-text);" (click)="ctxClose(contextMenu()!.tabId)">
    <span class="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0"
      style="background:var(--dropdown-hover)">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </span>
    Close Tab
  </button>

  <!-- Close Other Tabs -->
  <button class="ctx-menu-item w-full flex items-center gap-3 px-3.5 py-2 text-xs font-medium text-left"
    style="color: var(--dropdown-text);" (click)="ctxCloseOthers(contextMenu()!.tabId)">
    <span class="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0"
      style="background:var(--dropdown-hover)">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    </span>
    Close Other Tabs
  </button>

  <!-- Close Tabs to the Right -->
  <button class="ctx-menu-item w-full flex items-center gap-3 px-3.5 py-2 text-xs font-medium text-left"
    style="color: var(--dropdown-text);" (click)="ctxCloseToRight(contextMenu()!.tabId)">
    <span class="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0"
      style="background:var(--dropdown-hover)">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
      </svg>
    </span>
    Close Tabs to the Right
  </button>

  <!-- Divider -->
  <div class="my-1.5 mx-3" style="border-top: 1px solid var(--dropdown-border)"></div>

  <!-- Close All Tabs -->
  <button class="ctx-menu-item-danger w-full flex items-center gap-3 px-3.5 py-2 text-xs font-medium text-left"
    style="color: #ef4444;" (click)="ctxCloseAll()">
    <span class="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0"
      style="background:rgba(239,68,68,0.1)">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    </span>
    Close All Tabs
  </button>
</div>
}
